module.exports = __webpack_public_path__ + "static/media/Delete Blue.4b6a893e.svg";